import type React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import ExpertoBayerCatalogAction from '/@/components/experto-bayer-action';
import { isExpertoBayer } from '/@/core/settings';
import { useIsValidatedBayerUserType } from '/@/hooks/session';
import { _ } from '/@/locale';
import { getUser } from '/@/store/session/selectors';
import ExpertoBayerCatalogActionSrc from '/@/styles/assets/catalog/expertobayer-action.svg';
import AskExpCatalogActionSrc from './assets/AskExp.svg';
import BRCatalogActionSrc from './assets/chat-bot.png';
import CornCatalogActionSrc from './assets/corn-a.svg';

const type = ['corn', 'chat-bot', 'home'] as const;

interface CatalogActionProps {
    type: (typeof type)[number];
    text?: string;
    onClick?: () => void;
}

const defaultProps: Partial<CatalogActionProps> = {
    text: 'Elegir el mejor producto para mi lote y ambiente',
};

const CatalogAction: React.FC<CatalogActionProps> = ({ type, text, onClick }) => {
    const user = useSelector(getUser);
    const isValidatedBayerUserType = useIsValidatedBayerUserType();
    const isExperto = isExpertoBayer();

    const handleClick = useCallback(
        (e) => {
            if (onClick) onClick();
        },
        [onClick]
    );

    if (!user || (isValidatedBayerUserType && isExperto)) return null;

    const src = {
        corn: CornCatalogActionSrc,
        'chat-bot': BRCatalogActionSrc,
        home: AskExpCatalogActionSrc,
    };

    return (
        <ExpertoBayerCatalogAction
            src={isExperto ? ExpertoBayerCatalogActionSrc : src[type]}
            title={isExperto ? _('¡Hola!') : _(text)}
            description={isExperto ? _('CONSULTÁ A UN EXPERTO') : undefined}
            onClick={handleClick}
            sx={{ position: 'sticky', bottom: 15, width: 'fit-content', ml: 'auto', mr: 5 }}
        />
    );
};

CatalogAction.defaultProps = defaultProps;

export default CatalogAction;
